var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('h3',[_vm._t("subHeadline")],2),_vm._v(" "),(_vm.$slots.headline)?_c('h2',[_vm._t("headline")],2):_vm._e(),_vm._v(" "),_c('p',[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23719c16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/SectionHeadline.vue
// module id = null
// module chunks = 